<template>
  <div>
    <leftside
      :status="leftSideStatus"
      :key_name="keyName"
      :key_sku="keySku"
    ></leftside>
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyName="keyName"
        :keySku="keySku"
        :warehouseName="warehouseName"
        :warehouseAddress="warehouseAddress"
      ></Header>
      <router-view
        :first_loading="firstLoading"
        :items="items"
        v-if="isSysRights('Warehouse.getWarehouseDetail')"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/storage-details/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
    </div>
    <!-- 导入盘库数据 -->
    <modalImportStorage></modalImportStorage>
  </div>
</template>

<script>
import leftside from "./left-side.vue";
import Header from "./header.vue";
import { pagination } from "@components/pagination.js";
import modalImportStorage from "./modal-import-storage.vue";

export default {
  components: { leftside, Header, pagination, modalImportStorage },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("storage-details-rowsPerPage"))
        ? parseInt(store.get("storage-details-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      // 仓库名称
      warehouseName: "",
      // 仓库地址
      warehouseAddress: "",
      items: [],
      keyName: "",
      keySku: "",
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage() {
      store.set("storage-details-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    this.getItems();
  },
  methods: {
    getItems(s) {
      if (!this.isSysRights("Warehouse.getWarehouseDetail")) return;
      this.loading = true;
      $.api_call(
        "api.Warehouse.getWarehouseDetail",
        {
          warehouseId: this.$route.query.id,
          skuName: this.keyName,
          sku: this.keySku,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            const res = r.Data.Results || {};
            this.warehouseName = res.name;
            this.warehouseAddress = `${res.province}-${res.city}-${res.area}-${res.address}`;
            this.items = res.skus || [];
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            if (!s) $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({
        path: "/storage-details/" + 1,
        query: this.$route.query,
      });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({
        path: "/storage-details/" + num,
        query: this.$route.query,
      });
      if (page == num) {
        this.getItems();
      }
    },
  },
};
</script>